'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface SavedSearch {
  id: string;
  name: string;
  filters: {
    species?: string;
    breed?: string;
    location?: string;
  };
  resultCount: number;
  lastUpdated: string;
}

interface SavedSearchesProps {
  searches: SavedSearch[];
  onLoad: (searchId: string) => void;
  onDelete: (searchId: string) => void;
}

const SavedSearches = ({ searches, onLoad, onDelete }: SavedSearchesProps) => {
  if (searches.length === 0) return null;

  return (
    <div className="bg-card rounded-lg shadow-md border border-border p-4 mb-6">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="BookmarkIcon" size={20} variant="solid" className="text-primary" />
        <h3 className="text-lg font-headline font-semibold text-foreground">Saved Searches</h3>
      </div>

      <div className="space-y-2">
        {searches.map((search) => (
          <div
            key={search.id}
            className="flex items-center justify-between p-3 bg-background rounded-lg border border-border hover:border-primary transition-colors"
          >
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-foreground truncate">{search.name}</h4>
              <div className="flex items-center space-x-2 mt-1">
                <span className="text-xs text-muted-foreground">
                  {search.filters.species && `${search.filters.species} • `}
                  {search.filters.breed && `${search.filters.breed} • `}
                  {search.filters.location}
                </span>
              </div>
              <div className="flex items-center space-x-3 mt-2">
                <span className="text-xs text-brand-cta font-semibold">{search.resultCount} pets found</span>
                <span className="text-xs text-muted-foreground">Updated {search.lastUpdated}</span>
              </div>
            </div>
            <div className="flex items-center space-x-2 ml-4">
              <button
                onClick={() => onLoad(search.id)}
                className="p-2 hover:bg-muted rounded-lg transition-colors"
                aria-label="Load search"
              >
                <Icon name="ArrowPathIcon" size={18} variant="outline" className="text-primary" />
              </button>
              <button
                onClick={() => onDelete(search.id)}
                className="p-2 hover:bg-muted rounded-lg transition-colors"
                aria-label="Delete search"
              >
                <Icon name="TrashIcon" size={18} variant="outline" className="text-error" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedSearches;